var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.2 3.75a.5.5 0 0 0-.339.126.32.32 0 0 0-.111.235v7.778c0 .076.032.162.111.235a.5.5 0 0 0 .339.126h9.6a.5.5 0 0 0 .339-.126.32.32 0 0 0 .111-.235v-5.96a.32.32 0 0 0-.111-.235.5.5 0 0 0-.339-.126H7.71l-2-1.818zm-1.358-.975A2 2 0 0 1 3.2 2.25h3.09l2 1.818h4.51a2 2 0 0 1 1.358.525c.371.344.592.823.592 1.336v5.96c0 .513-.22.992-.592 1.336a2 2 0 0 1-1.358.525H3.2a2 2 0 0 1-1.358-.525 1.82 1.82 0 0 1-.592-1.336V4.11c0-.513.22-.992.592-1.336z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;